<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<div class="pre" id="pre-001"><span epub:type="pagebreak" id="page_VII" title="VII">
<div class="enc2"><h1 class="pre_tit" epub:type="title"><span><span class="small">A<span class="small">BBREVIATIONS</span></span></span></h1></div><span class="small">
<div class="dev">
<div class="tableau" id="tab01">
<div class="table-align">
<table style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:1px;">
<col style="width:20%;"/>
<col style="padding:1px;"/>
</colgroup>
<tbody>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">ANF</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">The Ante-Nicene Fathers. 10 vols. Edited by Alexander Roberts and James Donaldson. Buffalo, NY: Christian Literature, 1885–1896. Several reprints; also available online.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">CTS</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">Calvin Translation Society edition of Calvin’s commentaries. 46 vols. Edinburgh, 1843–1855. Several reprints but variously bound; volume numbers (when cited) are relative to specific commentaries and not to the entire set.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">DBWE</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">Dietrich Bonhoeffer Works. Vol. 15. Theological Education Underground, 1937–1940. Edited by Victoria Barnett. Minneapolis: Fortress, 2011.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">EEBO</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">Early English Books Online. Subscription database: <a class="url" href="http://eebo.chadwyck.com" target="_blank">http://eebo.chadwyck.com</a>.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">HAB</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">Herzog August Bibliothek</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Institutes</i></p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">John Calvin. <i>Institutes of the Christian Religion</i>. 2 vols. Edited by J. T. McNeill. Translated by F. L. Battles. Philadelphia: Westminster, 1960.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">LCC</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">Library of Christian Classics</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">LW</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">Luther’s Works [American Edition]. 55 vols. St. Louis: Concordia; Philadelphia: Fortress, 1955–1986.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">NPNF</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church. 28 vols. Edited by Philip Schaff et al. Buffalo, NY: Christian Literature, 1887–1894. Several reprints; also available online.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea"><span epub:type="pagebreak" id="page_VIII" title="VIII">OER</span></p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Oxford Encyclopedia of the Reformation</i>. 4 vols. Edited by Hans J. Hillerbrand. New York: Oxford University Press, 1996.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">PL</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">Patrologia cursus completus. Series Latina. 221 vols. Edited by J.–P. Migne. Paris, 1857–1866.</p></td>
</tr>
<tr style="padding:1px;vertical-align:top;">
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">WA</p></td>
<td style="padding:1px;vertical-align:top;"><p class="txt_courant_ssalinea">D. Martin Luthers Werke: Kritische Gesamtausgabe. 66 vols. Weimar: Hermann Böhlaus Nachfolger, 1912–1921.</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</span></span></div><span class="small">
</span></section><span class="small">
</span>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre2.vue?5f8b8670